module.exports = __webpack_public_path__ + "puxi_banner.png?b1d287dc326b238aa7b87cd767402909";